module.exports = __webpack_public_path__ + "static/media/tavatar-kate.b2566301.png";